import axios from 'axios';

import { GetTestPacientIdResponse } from './types';
import {
  interceptorRequestAuthentication,
  interceptorResponseErrorsPromise,
  interceptorResponseTransformData,
} from 'services/iclinic/interceptors';

const apiOnBoarding = axios.create({
  baseURL: process.env.ICLINIC_API_URL,
});

apiOnBoarding.interceptors.request.use(interceptorRequestAuthentication);
apiOnBoarding.interceptors.response.use(
  interceptorResponseTransformData,
  interceptorResponseErrorsPromise,
);

export const disableOnboardingFeatureToogle = (physicianId: number) =>
  apiOnBoarding.post(
    `/accounts/physician/${physicianId}/disable_onboarding_modal/`,
  );

export const getTestPacientId = () =>
  apiOnBoarding.get<GetTestPacientIdResponse>(
    '/patients/patient/test_patient/',
  );
